import { IConfigService } from '../config/ConfigService';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class RoleService implements IService {
    private readonly ItemResource;

    constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
      const roleResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/role/:id`,
        {id: "@id", projectId: "@projectId"},
        {update: {method: "PUT"}});

      this.ItemResource = resourceWrapperService.WrapActions(roleResource);
    }

    public findByProjectId(projectId: string, callBack: Function) {
      return this.ItemResource.query({projectId: projectId}, (roles) => callBack && callBack(roles));
    }

    public create(role: any) {
      return new this.ItemResource(role);
    }

    public save(role: any, callBack: Function, errorCallBack: Function) {
      return role.id ? this.update(this.create(role), callBack, errorCallBack) : this.add(this.create(role), callBack, errorCallBack);
    }

    public add(item, callBack: Function, errorCallBack: Function) {
      item.$save((role) => callBack && callBack(role), (response) => errorCallBack && errorCallBack(response.data));
    }

    public update(item, callBack: Function, errorCallBack: Function) {
      item.$update((role) => callBack && callBack(role), (response) => errorCallBack && errorCallBack(response.data));
    }

    public delete(item, callBack: Function, errorCallBack: Function) {
      item.$delete((role) => callBack && callBack(role), (response) => errorCallBack && errorCallBack(response.data));
    }

    public isAdmin(roles) {
      return this.hasPermission(roles, "ADMIN_PROJECT");
    }

    public hasPermission(roles, permission) {
      return roles?.some(r => r.permissions?.includes(permission)) ?? false;
    }
}

frontendApp.factory("RoleService", ["$resource", "ConfigService", "ResourceWrapperService", function($resource, configService, resourceWrapperService) {
  return new RoleService($resource, configService, resourceWrapperService);
}]);
